/*
 * @Description: 填写描述
 * @Author: 填写作者
 * @Date: 2022-01-10 23:36:19
 */
export default function checkLogin() {
  return !!localStorage.getItem('access_token');
}
